var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BigNumber } from "@ethersproject/bignumber";
import { formatUnits } from "@ethersproject/units";
import { useCallback, useContext, useEffect, useState } from "react";
import { LidoOracleFactory } from "../codegen/LidoOracleFactory";
import { LidoOracleAddress } from "../constants/constants";
import { isProduction } from "../utils/env";
import { useETHWeb3Context } from "./web3Context";
import { Web3DataContext } from "./web3DataContext";
export var getLidoOracle = function (library, useSigner) {
    if (useSigner === void 0) { useSigner = true; }
    if (!LidoOracleAddress) {
        return null;
    }
    var provider = useSigner ? library.getSigner() : library;
    return LidoOracleFactory.connect(LidoOracleAddress, provider);
};
export var defaultLidoOracleData = {
    data: {
        preTotalPooledEther: BigNumber.from(0),
        postTotalPooledEther: BigNumber.from(0),
        timeElapsed: 0,
    },
    loading: true,
};
export var useFetchLidoOracleData = function () {
    var provider = useETHWeb3Context().provider;
    var _a = useState(defaultLidoOracleData), data = _a[0], setData = _a[1];
    var fetchLidoOracleData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var contract, responses;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isProduction()) {
                        console.time("Lido Oracle Data Fetch"); // eslint-disable-line
                    }
                    contract = getLidoOracle(provider, false);
                    if (!contract) {
                        setData(function (prev) { return (__assign(__assign({}, prev), { loading: false })); });
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, contract.getLastCompletedReportDelta()];
                case 1:
                    responses = _a.sent();
                    setData({
                        data: {
                            preTotalPooledEther: responses.preTotalPooledEther,
                            postTotalPooledEther: responses.postTotalPooledEther,
                            timeElapsed: parseFloat(responses.timeElapsed.toString()),
                        },
                        loading: false,
                    });
                    if (!isProduction()) {
                        console.timeEnd("Lido Oracle Data Fetch"); // eslint-disable-line
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [provider]);
    useEffect(function () {
        fetchLidoOracleData();
    }, [fetchLidoOracleData]);
    return data;
};
var useLidoAPY = function () {
    var contextData = useContext(Web3DataContext);
    var preTotalPooledEther = parseFloat(formatUnits(contextData.lidoOracle.data.preTotalPooledEther, 18));
    var postTotalPooledEther = parseFloat(formatUnits(contextData.lidoOracle.data.postTotalPooledEther, 18));
    var secondsInYear = 60 * 60 * 24 * 365;
    return contextData.lidoOracle.loading
        ? 0
        : ((postTotalPooledEther - preTotalPooledEther) * secondsInYear) /
            (preTotalPooledEther * contextData.lidoOracle.data.timeElapsed);
};
export default useLidoAPY;
//# sourceMappingURL=useLidoOracle.js.map